import CONSTANTS from '../constants';

export function spinner(state = false, action) {
  switch (action.type) {
    case CONSTANTS.ACTIONS.SPINNER.SHOW:
      return true;
    case CONSTANTS.ACTIONS.SPINNER.HIDE:
      return false;
    default:
      return state;
  }
}
